/* eslint-disable prettier/prettier */
export const API_ROOT = process.env.NODE_ENV === 'development' ? 'https://api-main.karobartechnologies.com/api' : 'https://api-main.karobartechnologies.com/api';
export const API_URL = process.env.NODE_ENV === 'development' ? 'https://api-main.karobartechnologies.com/api' : 'https://api-main.karobartechnologies.com/api';
